import React from 'react';
import styled from 'styled-components';
import { Badge } from "../Badge";
import { MATCHING_ROUND_COLORS } from './colors';

const BadgeContainer = styled.div`
    display: inline-block;
    .MuiBox-root {
        top: -3px;
        position: relative;
    }
    span {
        position: relative !important;
        display: block !important;
    }
`;

interface IProps {
  status: string;
}

export const MatchingRoundBadge: React.FC<IProps> = ({status}) => {
  const getBadgeVariant = (status: string) => (
    {
        backgroundColor: MATCHING_ROUND_COLORS[status].bg, 
        color: MATCHING_ROUND_COLORS[status].text,
    }
  );
  return (<BadgeContainer>
  <Badge badgeContent={status} style={getBadgeVariant(status)} />
  </BadgeContainer>);
};